import React from "react";
import "../styles/GuidedLearner.css";

const QuickPrep = ({ features, limitations }) => {
  return (
    <div className="GuidedLearner">
      <div className="fw700">Short-Term Access Plan - “Quick Prep”</div>
      <div className="collections">
        <div className="collection1">
          <div className="info">
            <span className="fw700">Price:</span> $30 for 1 month (no recurring payment, ($40 -25% discount))
          </div>
          <div className="info">
            <span className="fw700">Target Audience:</span> Students who need a last-minute boost or quick review before their upcoming SAT
          </div>
        </div>

        <div className="collection2">
          <div className="section-title">Features</div>
          {features && features.length > 0 ? (
            features.map((feature, index) => {
              const [title, text] = feature.split(":"); // Split the string into title and text
              return (
                <div key={index} className="feature">
                  <span className="fw700">{title}:</span> {text}
                </div>
              );
            })
          ) : (
            <div className="feature">No features available.</div>
          )}
        </div>

        <div className="collection3">
          <div className="limitations">
            <span className="fw700">Limitations:</span> {limitations}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickPrep;